import React from 'react';
const VARIANTS = {
  success: { bg: '#D1FAE5', color: '#065F46' },
  error:   { bg: '#FEE2E2', color: '#991B1B' },
  warning: { bg: '#FEF3C7', color: '#92400E' },
  info:    { bg: '#DBEAFE', color: '#1E40AF' },
  teal:    { bg: '#CFFAFE', color: '#164E63' },
  purple:  { bg: '#EDE9FE', color: '#5B21B6' },
  grey:    { bg: '#F3F4F6', color: '#374151' },
  gold:    { bg: '#FEF9C3', color: '#713F12' },
  orange:  { bg: '#FFEDD5', color: '#9A3412' },
};
const CEFR_COLORS = { A1:'grey', A2:'info', B1:'teal', B2:'success', C1:'orange', C2:'gold' };

export default function Badge({ label, variant='info', dot=false }) {
  const s = VARIANTS[variant] || VARIANTS.info;
  return (
    <span className="badge" style={{ background: s.bg, color: s.color }}>
      {dot && <span className="pulse-dot" style={{ background: s.color, marginRight: 5 }} />}
      {label}
    </span>
  );
}
export function CefrBadge({ level }) {
  const v = CEFR_COLORS[level] || 'grey';
  return <Badge label={level} variant={v} />;
}
export function TierBadge({ tier }) {
  return <Badge label={`Tier ${tier}`} variant={tier === 1 ? 'teal' : 'purple'} />;
}
export function StatusBadge({ status }) {
  const map = { Active:'success', Suspended:'error', Pending:'warning', active:'success', suspended:'error', pending:'warning', approved:'success', available:'success', busy:'warning', offline:'grey' };
  return <Badge label={status} variant={map[status]||'grey'} dot />;
}
